class RequiredFieldIndicators {
  constructor(root = document) {
    this.add(root);

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) this.add(node);
        });
      });
    });

    this.observer.observe(document.body, { childList: true, subtree: true });
  }

  add(root) {
    const controls = [];

    if (root.matches?.('input[required], select[required], textarea[required]')) {
      controls.push(root);
    }

    controls.push(...root.querySelectorAll?.('input[required], select[required], textarea[required]') || []);

    controls.forEach((control) => this.addIndicator(control));
  }

  addIndicator(control) {
    if (control.type === 'hidden') return;

    const label = Array.from(control.labels || []).find((candidate) => !candidate.classList.contains('visually-hidden'));
    if (!label) return;

    const existingIndicator = Array.from(label.querySelectorAll('span')).find(
      (span) => span.textContent.trim() === '*'
    );

    if (existingIndicator) {
      existingIndicator.classList.add('required-field-indicator');
      existingIndicator.setAttribute('aria-hidden', 'true');
      return;
    }

    const indicator = document.createElement('span');
    indicator.className = 'required-field-indicator';
    indicator.setAttribute('aria-hidden', 'true');
    indicator.textContent = '*';

    const supportingText = label.querySelector(
      '.field__hint, .physician-register__helper, .training-form-revamp__hint, .training-form-revamp__error'
    );

    label.insertBefore(indicator, supportingText);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new RequiredFieldIndicators();
});
